import { render, staticRenderFns } from "./ClientOfficeCosts.vue?vue&type=template&id=0e47ad0e&scoped=true"
import script from "./ClientOfficeCosts.vue?vue&type=script&lang=js"
export * from "./ClientOfficeCosts.vue?vue&type=script&lang=js"
import style0 from "./ClientOfficeCosts.vue?vue&type=style&index=0&id=0e47ad0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47ad0e",
  null
  
)

export default component.exports